import React from 'react';
import { Hero } from './components/Hero';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PainSection } from './components/PainSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { OfferSection } from './components/OfferSection';
import { AcceleratorSection } from './components/AcceleratorSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { CostSection } from './components/CostSection';
import { Footer } from './components/Footer';
import { TOP_TESTIMONIALS, MORE_TESTIMONIALS } from './components/salesData';
export function App() {
  return <main className="w-full bg-cream text-ink" data-id="element-0" data-mp="2wifbn1k4umsw">
      <Hero data-id="element-1" data-mp="28u5uwe1s0p8m" />
      <TestimonialsSection title="Lo que dicen las dueñas" items={TOP_TESTIMONIALS} variant="cream" data-id="element-2" data-mp="28tmg367fagyt" />
      <PainSection data-id="element-3" data-mp="23w4ey1znd61d" />
      <TomosSection data-id="element-4" data-mp="23ujho4ly78zt" />
      <BonosSection data-id="element-5" data-mp="23t8hsfvmildz" />
      <OfferSection data-id="element-6" data-mp="3ijxnsm94vshs" />
      <AcceleratorSection data-id="element-7" data-mp="3ikh9me1wn113" />
      <TestimonialsSection title="❤️ Más dueñas de estéticas que ya lo tienen" items={MORE_TESTIMONIALS} variant="cream" data-id="element-8" data-mp="3ij65ue8glt9z" />
      <GuaranteeSection data-id="element-9" data-mp="3rcj6618urx63" />
      <FaqSection data-id="element-10" data-mp="3rbzngibdp4r0" />
      <CostSection data-id="element-11" data-mp="3rdkl4gszp3t3" />
      <Footer data-id="element-12" data-mp="3recerm310rgq" />
    </main>;
}